import { TabTitle } from "../utils/helperFunctions";

//Thank you Page
function Thanks() {
  TabTitle("Thank You!");

  return (
    <div
      style={{ height: window.innerHeight }}
      className="ui grid "
      id="landingPage"
    >
      {/* <div className="ui column" style={{ backgroundColor: "black" }}>
      <img
        className="ui image big centered rounded"
        style={{ marginTop: "6rem" }}
        alt={"Me"}
        src={picture}
      ></img>
    </div> */}
      <div
        className="ui column container"
        style={{ alignSelf: "center", textAlign: "center" }}
      >
        <img
          className="ui image centered rounded"
          alt={"Business logo"}
          src={"/img/logo.webp"}
          style={{ width: "400px", objectFit: "none" }}
        ></img>
        <p>
          <span className="ui text large" style={{ fontSize: "1.2rem" }}>
            Thank you for reaching out to my business, I'll get back to you at
            my best convenience!
          </span>
        </p>
        <br></br>
        <p>
          <a href="/services">
            <button
              className="ui button huge inverted basic learnMore teal circular"
              id="submitText"
            >
              Return Home
            </button>
          </a>
        </p>
      </div>
    </div>
  );
}

export default Thanks;
